module.exports = "<div class=\"hint\">\nعن اضافة ملف صوت يجب ان لا يتعدي ١٠٠ ميجا\n</div>\n"